export default __webpack_public_path__ + "static/media/AARP Dark.6fc96cf6.svg";